import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import lodash from "lodash";
import React from 'react';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import * as constants from '../../util/constants';
import Propertii from './Propertii';
import Modal from "./Modal";

class CreditReporting extends Propertii {
  /**
   * Initialize the component.
   *
   * @param props - The properties of the component.
   */
  constructor(props) {
    super(props);

    this.state = {
      creditReportingStatus: 'INACTIVE',
      creditReportingId: ''
    };
    this.getCustomerCreditReport = this.getCustomerCreditReport.bind(this);
    this.stopCustomerCreditReport = this.stopCustomerCreditReport.bind(this);
  }

  componentDidMount() {
    this.getCustomerCreditReport();
  }

  /**
   * Get details of user credit reporting
   */
  getCustomerCreditReport() {
    axios
        .post(
            `${constants.REACT_APP_HOST_API_URL}/credit_report/search`,
            {
              orderBy: 'ASC',
              conditionList: [
                {
                  type: 'STRING',
                  logicalOperator: 'AND',
                  openBrackets: null,
                  closeBrackets: null,
                  operator: 'EQUALS',
                  fieldName: 'billingAccountId',
                  fieldValue: this.props.propertyLeaseId,
                },
              ],
            },
            {
              headers: this.generateRequestHeaders(),
            }
        )
        .then((response) => {
          if (response.data.records.length) {
            this.setState((prevState) => ({
              ...prevState,
              creditReportingStatus: response.data.records[0]?.status,
              creditReportingId: response.data.records[0]?.id
            }));
          }
        })
        .catch((error) => {
          this.handleValidation(error);
        });
  }

  /**
   * Manually stop the credit reporting to the tenant for the current term.
   */
  stopCustomerCreditReport() {

    this.setState({
      spinner: true,
    });

    axios.get(`${constants.REACT_APP_HOST_API_URL}/credit_report/${this.state.creditReportingId}/stop`,  {
      headers: this.generateRequestHeaders()
    }).then(response => {

      if (response.data?.status) {
        this.setState((prevState) => ({
          ...prevState,
          spinner: false,
          creditReportingStatus: response.data?.status
        }));
      }

    }).catch(error => {
      this.handleValidation(error);
    });

  }

  /**
   * Render the component.
   *
   * @returns {*} - The customer notes component.
   */
  render() {
    return (
        <React.Fragment>
          <div className='card'>
            <div className='card-header'>
              <div className='row align-items-center'>
                <div className='col'>CreditReporting</div>
                <div className="col text-right">

                  <div className="dropdown">

                    {this.props.userType === 'TYPE_ADMIN' && this.state.creditReportingId && this.state.creditReportingStatus === 'ACTIVE' &&
                        <div className="btn btn-primary btn-sm dropdown-toggle" role="button" id="statement-actions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Actions
                        </div>
                    }

                    <div className="dropdown-menu" aria-labelledby="statement-actions">

                      {this.state.creditReportingStatus === 'ACTIVE' &&
                          <div data-toggle="modal" data-target="#stop-credit-reporting" className="dropdown-item c-pointer">
                            <FontAwesomeIcon icon={['fas', 'mailbox']} className="fa-fw" /> Cancel Credit Reporting
                          </div>
                      }

                    </div>

                  </div>

                </div>
              </div>
            </div>

            <div className='col my-3'>
              <p className='mb-0'>
                Credit Reporting:
                <strong className={'float-right'}>
                <span className={this.state.creditReportingStatus === 'ACTIVE' ? 'text-primary' : 'text-danger'}>
                  {lodash.startCase(lodash.toLower(this.state.creditReportingStatus))}
                  <FontAwesomeIcon icon={['fas', 'circle']} className={'fa-fw small ml-2'} />
                </span>
                </strong>
              </p>
            </div>
          </div>

          <Modal id="stop-credit-reporting" theme="primary" iconType="fas" iconName="question-circle" title="Cancel Credit Reporting" body="Are you sure you would like to stop this tenant's credit reporting for the current term?">
            <button type="button" className="btn btn-outline-primary btn-lg my-2" data-dismiss="modal">
              <FormattedMessage id="button.close" />
            </button>
            <button onClick={() => {this.stopCustomerCreditReport()}} className="btn btn-primary btn-lg my-2" data-dismiss="modal">
              Cancel Credit Reporting
            </button>
          </Modal>

        </React.Fragment>
    );
  }
}

CreditReporting.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(CreditReporting);
